import api from '@/api/api';

const DOMAIN = '/questions';

const get = async (): Promise<Array<Questions.Question>> => {
	const { data } = await api.get(`${DOMAIN}`);
	return data;
};

const create = async (body: Questions.Create): Promise<Questions.Question> => {
	const { data } = await api.post(`${DOMAIN}`, body);
	return data;
};

const update = async ({
	id,
	body,
}: {
	id: string;
	body: Questions.Create;
}): Promise<Questions.Question> => {
	const { data } = await api.patch(`${DOMAIN}/${id}`, body);
	return data;
};

const destroy = async (id: string): Promise<void> => {
	await api.delete(`${DOMAIN}/${id}`);
};

const QuestionsService = {
	get,
	create,
	update,
	destroy,
};

export { QuestionsService };
